module.exports = __webpack_public_path__ + "a1e75826e73dcd86befbe95e41373a6a.fbx";